<template>
    <div>
        <data-grid ref="dataGrid"
                   :settings="grid"
                   :page="page"
                   :storeDispatchList="loadGridData"
                   :hidePaginator="hidePaginator"
                   v-on:changePage="$emit('changePage', $event)"
                   v-on:button-edit="openOrder($event)"
                   v-on:button-delete="deleteItem($event)"
        >
            <template slot="fullName" slot-scope="data">
                <router-link :to="{name: 'manageApplication', params: {id: data.item.id}}"
                             class="link"
                >
                  <div class="app-patient-logo">
                    <img src="/static/insurance/dovera.svg"
                         v-if="data.item.patient.insurance.code === 24"
                         class="insurance-logo"
                         :alt="data.item.patient.insurance.insuranceName"
                    >
                    <img src="/static/insurance/vszp.png"
                         v-if="data.item.patient.insurance.code === 25"
                         class="insurance-logo"
                         :alt="data.item.patient.insurance.insuranceName"
                    >
                    <img src="/static/insurance/union.svg"
                         v-if="data.item.patient.insurance.code === 27"
                         class="insurance-logo"
                         :alt="data.item.patient.insurance.insuranceName"
                    >
                  </div>
                  <div class="app-patient-info">
                    <div>{{data.item.patient.fullName}}</div>
                    <div v-if="isTestUser && data.item.protocol" class="app-info text-muted">{{data.item.protocol.shortName}}</div>
                  </div>
                </router-link>
                <div class="badge badge-primary" v-if="data.item.mailCount > 0">{{data.item.mailCount}}</div>
            </template>
            <template slot="applicationState" slot-scope="data">
                <change-state :id="data.item.id"
                              :item="data.item"
                              :currentState="data.item.status"
                              @changeState="updateGrid()"
                />

                <div v-if="data.item.status.slug==='accepted'"
                     class="badge c-pointer badge-light"
                     :title="t('Prescribed packages') + ' ' + t('Approved packages')"
                     @click="openPrescription(data.item)"
                >
                    {{data.item.prescribed|number}} / {{data.item.approvedPackages|number}} {{t('packages')}}
                </div>
            </template>
            <template slot="submitDate" slot-scope="data">
                <template v-if="data.item.status.slug !== 'concept'">
                    <change-date parameter="submitDate"
                                 :id="data.item.id"
                                 :date="data.item.submitDate"
                                 :minDate="new Date(data.item.minSubmitDate)"
                                 @changeState="updateGrid()"
                    />
                </template>
            </template>
            <template slot="approvalDate" slot-scope="data">
                <change-date parameter="approvalDate"
                             :id="data.item.id"
                             :date="data.item.approvalDate"
                             :minDate="new Date(data.item.minApprovalDate)"
                             v-if="data.item.status.slug !== 'concept' && data.item.submitDate"
                             @changeState="updateGrid()"
                />
            </template>
            <template slot="expiryDate" slot-scope="data">
                <change-date parameter="expiryDate"
                             :id="data.item.id"
                             :date="data.item.expiryDate"
                             :minDate="new Date(data.item.minExpiryDate)"
                             v-if="data.item.status.slug !== 'concept' && data.item.approvalDate"
                             @changeState="updateGrid()"
                />
                <expire-badge :expire-in="data.item.expireIn"/>
            </template>
            <div class="d-inline-block" slot="after-actions" slot-scope="data">
<!--                <download-button color="secondary" :link="data.item.downloadLink"/>-->
              <client-side-download-button :application="data.item" />
            </div>
        </data-grid>
        <prescription ref="prescriptionModal"
                      v-if="prescriptionModal !== null"
                      :id="prescriptionModal.id"
                      :prescribed="prescriptionModal.prescribed"
                      :approved="prescriptionModal.approvedPackages"
                      @added="updateGrid()"
        />
    </div>
</template>

<script>
    import DataGrid from '../../../core/InlineDataGrid/DataGrid'
    import AcceptAction from '../../../core/AcceptAction';
    import ChangeState from './change-state';
    import ChangeDate from './change-date';
    import SendApplication from './send-application';
    import ExpireBadge from './expire-badge';
    import DownloadButton from './download-button';
    import ClientSideDownloadButton from './client-side-download-button';
    import Prescription from './prescription';

    export default {
        components: {
            Prescription,
            DownloadButton,
            ClientSideDownloadButton,
            ExpireBadge,
            SendApplication,
            AcceptAction,
            DataGrid,
            ChangeState,
            ChangeDate,
        },
        props: {
            storeDispatchParams: {
                required: false,
            },
            hidePaginator: {
                type: Boolean,
                default: false,
            },
            sortable: {
                type: Boolean,
                default: true,
            },
            showPatient: {
                type: Boolean,
                default: true,
            },
            page: {
                type: Number,
                'default': 1,
            },
            patientId: {
                type: Number | null,
                required: false,
                default: null,
            },
        },
        mounted() {
            this.initGridColumns();
        },
        methods: {
            isTestUser() {
                return this.$store.state.account.user.testUser;
            },
            openPrescription(data) {
                this.prescriptionModal = data;
                if (data !== null) {
                    setTimeout(() => {
                        this.$refs.prescriptionModal.open()
                    }, 200);
                }
            },
            loadGridData(params) {
                if (this.patientId !== null) {
                    params.conditions.push({
                        key: 'patient->parent->id',
                        value: this.patientId,
                    });
                }
                this.loading = true;
                return this.$store.dispatch('applications/list', params).then(res => {
                    this.loading = false;
                    return res;
                });
            },
            updateGrid() {
                this.$refs.dataGrid.fetchData();
                this.$emit('updated');
            },
            deleteItem(entity) {
                this.$store.dispatch('applications/remove', entity.id).then(() => {
                    this.updateGrid();
                });
            },
            initGridColumns() {
                if (true === this.showPatient) {
                    this.grid.columns = [{
                        type: 'string',
                        name: this.t('Patient name'),
                        key: 'fullName',
                        sortable: this.sortable,
                        sortField: ['patient.name', 'patient.surname'],
                        filter: {
                            field: ['patient.name', 'patient.surname'],
                            type: 'fulltext',
                            likeType: '%_like_',
                        },
                    }];
                }
                this.grid.columns = this.grid.columns.concat([
                    {
                        type: 'string',
                        name: this.t('State'),
                        key: 'applicationState',
                        sortable: false,
                        filter: {
                            type: 'select',
                            codeBook: 'applicationsStatuses',
                            valueLabel: 'status',
                            field: 'status.id',
                        },
                    }, {
                        type: 'date',
                        name: this.t('Sent on'),
                        key: 'submitDate',
                        sortable: this.sortable,
                        filter: {
                            type: 'dateRange',
                        },
                    }, {
                        type: 'date',
                        name: this.t('Approved on'),
                        key: 'approvalDate',
                        sortable: this.sortable,
                        filter: {
                            type: 'dateRange',
                        },
                    }, {
                        type: 'date',
                        name: this.t('Expire on'),
                        key: 'expiryDate',
                        sortable: this.sortable,
                        filter: {
                            type: 'dateRange',
                        },
                    }, {
                        type: 'number',
                        name: this.t('Order number'),
                        key: 'applicationNumber',
                        sortable: this.sortable,
                        filter: {
                            type: 'number',
                        },
                    }
                ]);
            },
        },
        data() {
            return {
                headerButtons: [
                    {
                        type: 'link',
                        to: {name: 'createApplication', params: {page: 1}},
                        key: 'create',
                        name: this.t('Create'),
                        icon: 'plus',
                        styleClass: 'btn-success',
                    }
                ],
                prescriptionModal: null,
                grid: {
                    buttons: [
                        {
                            type: 'link',
                            to: (item) => {
                                return {
                                    name: 'manageApplication',
                                    params: {id: item.id},
                                };
                            },
                            name: this.t('Edit'),
                            icon: 'pencil-alt',
                            styleClass: 'btn-primary btn-sm',
                        }, {
                            //     type: 'link',
                            //     to: (item) => {
                            //         return item.downloadLink;
                            //     },
                            //     name: this.t('Download'),
                            //     icon: 'cloud-download-alt',
                            //     styleClass: 'btn-success btn-sm',
                            //     target: '_blank',
                            //     visible: (item) => {
                            //         return item.status.slug !== 'concept';
                            //     }
                            // }, {
                            type: 'action',
                            key: 'delete',
                            name: this.t('Delete'),
                            modalText: this.t('Do you want to delete application?'),
                            icon: 'times',
                            styleClass: 'btn-danger btn-sm',
                            visible: () => {
                                return this.hasPermission('ApplicationsTitan', 'D');
                            },
                        }
                    ],
                    columns: [],
                },
            }
        },
    }
</script>
<style lang="scss">
  .app-patient-logo {
    float:left;
    width:55px;
    text-align: center;

    .insurance-logo {
      height: 15px;
      margin-top: 3px;
    }
  }

  .app-patient-info {
    float:left;
    /*width:70%;*/
    margin-left: 10px;
    .app-info {
      font-size:0.8em;
      max-width: 130px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/applications/grid.vue